<template>
  <q-modal
    v-model="visible"
    @hide="$emit('input', false)"
    ref="modal"
    :content-css="{width: '500px'}"
  >
    <div class="q-pa-lg">
      <h1>Новый проект</h1>
      <form
        autocomplete="off"
        novalidate
        @submit.prevent="createProject"
        method="post"
      >
        <q-field>
          <q-input
            stack-label="Название" 
            v-model="project.name"
          />
        </q-field>
        <q-field>
          <q-input 
            stack-label="Домен" 
            v-model="domain"
          />
        </q-field>
        <div class="row justify-end q-mt-md">
          <q-btn 
            label="Создать" 
            type="submit" 
            color="primary" 
            class="q-mr-xs"
          />
          <q-btn 
            label="Отмена" 
            @click="hideModal" 
            color="primary" 
            flat
          />
        </div>
      </form>
    </div>
  </q-modal>
</template>

<script>
  import {
    QField,
    QInput,
    QSelect,
    QChipsInput,
    QBtn,
    QModal
  } from 'quasar';

  import {
    required,
    email,
    numeric
  } from 'vuelidate/lib/validators';

  export default {
    name: 'ProjectCreate',
    components: {
      QField,
      QInput,
      QSelect,
      QChipsInput,
      QBtn,
      QModal
    },
    props: {
      value: Boolean
    },
    computed: {
      visible: {
        get () {
          return this.value;
        },
        set () {
        }
      }
    },
    watch: {
      domain () {
        this.project.domains = [{
          fqdn: this.domain,
          redirect_to_https: false,
          ssl: 'NONE'
        }];
      }
    },
    data () {
      return {
        project: {
          name: null,
          has_custom: false,
          status: 'NEW',
          manager_id: null,
          ssl: false,
          domains: []
        },
        domain: [],
        manager: {
          id: '',
          first_name: '',
          last_name: ''
        },
        managersOptions: [],
        statusesOptions: [],
        loading: false
      };
    },
    validations: {
      project: {
        first_name: {required},
        last_name: {required},
        email: {required, email},
        phone_number: {required, numeric},
        password: {required}
      }
    },
    mounted () {

    },
    methods: {
      fetch () {
        this.fetchManagers();
        this.fetchStatuses();
      },
      createProject () {
        this.$http.post(`api/v1.0/projects`, this.project).then(response => {
          this.$router.push(`${window.location.pathname}/${this.getNewProjectId(response.headers.location)}`);
        }).catch(error => {

        });
      },
      getNewProjectId (location) {
        let chunks = location.split('/');

        return chunks[chunks.length - 1];
      },
      hideModal () {
        this.$refs.modal.hide();
      },
      fetchManagers () {
        this.$http.get(`api/v1.0/users/?filter[role]=manager`).then(response => {
          this.managers = response.data.users;

          this.managersOptions = response.data.users.map(
            user => {
              return {
                label: `${user.first_name} ${user.last_name}`,
                value: user.id
              };
            }
          );
        });
      },
      fetchStatuses () {
        this.$http.get(`api/v1.0/statuses`).then((response) => {
          this.statuses = response.data;
          _.forOwn(response.data, (value, key) => {
            this.statusesOptions.push({
              label: value,
              value: key
            });
          });
        });
      }
    }
  };
</script>






// WEBPACK FOOTER //
// resources/assets/js/components/ProjectCreate/ProjectCreate.vue